import { useEffect, useRef } from "react";

const AD_CLIENT = "ca-pub-6711409267761750";

/**
 * 애드센스 광고 칸. 토론이 끝난 화면에만 둔다 — 토론하는 화면에는 넣지 않는다.
 *
 * 광고가 실제로 채워졌을 때만 보인다(styles.css 의 .ad). 심사 전이나 채울 광고가
 * 없을 때 빈 상자가 남지 않게. display:none 으로 숨기면 폭이 0 이라 요청이 실패한다.
 */
export default function AdSlot({ slot }) {
  const ref = useRef(null);
  useEffect(() => {
    // StrictMode 는 effect 를 두 번 부른다. 이미 요청한 칸에 또 push 하면 애드센스가 오류를 낸다.
    if (!ref.current || ref.current.dataset.adsbygoogleStatus) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // 광고 차단기 등. 결과 화면을 깨뜨리지 않는다.
    }
  }, []);
  return (
    <aside className="ad" aria-label="광고">
      <p className="ad-label">광고</p>
      <ins ref={ref} className="adsbygoogle" style={{ display: "block" }}
        data-ad-client={AD_CLIENT} data-ad-slot={slot}
        data-ad-format="auto" data-full-width-responsive="true" />
    </aside>
  );
}
